import { Link } from "react-router-dom";
import { Phone, MapPin, ArrowUpRight } from "lucide-react";
import { CONTACT } from "@/data/site";

export default function Footer() {
  return (
    <footer className="bg-ink text-gray-300 noise" data-testid="site-footer">
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="inline-block bg-white px-4 py-2 mb-6">
            <img src="/assets/logo.png" alt="Fluton Global Metalcraft FZCO" className="h-9 w-auto" />
          </div>
          <p className="text-sm leading-relaxed text-gray-400 max-w-sm">
            Exporting and trading premium recyclable metals from Dubai to the world. A group
            company of the Ollexo Group of Companies.
          </p>
          <p className="font-tech text-xs uppercase tracking-[0.25em] text-copper mt-6">
            {CONTACT.sister}
          </p>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-tech text-xs uppercase tracking-[0.25em] text-gray-500 mb-6">Navigate</h4>
          <ul className="space-y-3 text-sm">
            {[
              ["Home", "/"],
              ["About", "/about"],
              ["Products", "/products"],
              ["Industries", "/industries"],
              ["Contact", "/contact"],
            ].map(([label, to]) => (
              <li key={to}>
                <Link
                  to={to}
                  data-testid={`footer-link-${label.toLowerCase()}`}
                  className="hover:text-copper transition-colors duration-200"
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="font-tech text-xs uppercase tracking-[0.25em] text-gray-500 mb-6">Reach Us</h4>
          <div className="space-y-4 text-sm">
            <p className="flex gap-3">
              <MapPin size={16} className="text-copper shrink-0 mt-0.5" />
              <span data-testid="footer-address">{CONTACT.address}</span>
            </p>
            <a
              href={CONTACT.phoneHref}
              data-testid="footer-phone"
              className="flex gap-3 hover:text-copper transition-colors duration-200"
            >
              <Phone size={16} className="text-copper shrink-0 mt-0.5" />
              {CONTACT.phone}
            </a>
            <a
              href={CONTACT.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp"
              className="group inline-flex items-center gap-2 border border-white/20 px-4 py-2.5 font-tech text-xs uppercase tracking-[0.2em] hover:border-copper hover:text-copper transition-colors duration-300"
            >
              WhatsApp Us
              <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          </div>
        </div>
      </div>

      <div className="relative z-10 border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col md:flex-row justify-between gap-3">
          <p className="font-tech text-xs text-gray-500" data-testid="footer-copyright">
            © {new Date().getFullYear()} Fluton Global Metalcraft FZCO. All rights reserved.
          </p>
          <p className="font-tech text-xs text-gray-600">Dubai Silicon Oasis · United Arab Emirates</p>
        </div>
      </div>
    </footer>
  );
}
